<template>
    <rkm-area
        type="fieldset"
        title="Pessoas avaliadas"
        show-legend
    >
        <rkm-row v-if="data.form">
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.paciente"
                    :search-fields="fields.autocomplete.paciente"
                    :validations="validations.paciente"
                    :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                    label="Nome"
                    v-model="data.model.participante.cidadao"
                    uppercase
                    :disabled="isAtividadeDisabled"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.participante.peso"
                    label="Peso (kg)"
                    :mask="maskPeso"
                    :validations="validations.peso"
                    :disabled="isAtividadeDisabled"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.participante.altura"
                    label="Altura (cm)"
                    :mask="maskAltura"
                    :validations="validations.altura"
                    :disabled="isAtividadeDisabled"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-checkbox
                    class="mt-4"
                    :value="true"
                    v-model="data.model.participante.avaliacaoAlterada"
                    :disabled="isAtividadeDisabled"
                >
                    Avaliação alterada
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-checkbox
                    class="mt-4"
                    :value="true"
                    v-model="data.model.participante.parouFumar"
                    :disabled="isAtividadeDisabled || isPnctDisabled"
                >
                    PNCT - Parou de fumar
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-checkbox
                    class="mt-4"
                    :value="true"
                    v-model="data.model.participante.abandonouGrupo"
                    :disabled="isAtividadeDisabled || isPnctDisabled"
                >
                    PNCT - Abandonou Grupo
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="5" class="text-right">
                <rkm-button
                    @click="save"
                    color="primary"
                    class="mt-4"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins
import { repository, error, object, formats, data, stringCase } from '@/mixins'

//Enums
import saudePratica from '@/enums/atencao-basica/atividade-coletiva/saudePratica'
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

export default {
    data: () => ({
        isPnctDisabled: true,
        model: {
            usuario: null,
            participantes: null
        },
        enums: {
            saudePratica,
            atividadeTipo,
            subclassificacao
        }
    }),
    computed: {
        isAtividadeDisabled() {
            if(this.data.model.atividade.totalParticipantes == '' || this.data.model.atividade.totalParticipantes == this.data.model.participantes.length) {

                return true
            } else if(this.data.model.atividade.totalParticipantes >= this.data.model.participantes.length) {

                return false
            } else if(this.data.model.atividade.totalParticipantes != '' && this.data.model.atividade.totalParticipantes < this.data.model.participantes.length) {

                return true
            } else {

                return true
            }
        },
        validations() {
            return {
                paciente: {
                    required: this.isRequiredPaciente
                },
                peso: {
                    min: 1,
                    max: 7,
                    min_value: 0.5,
                    max_value: 500
                },
                altura: {
                    min: 2,
                    max: 5,
                    min_value: 20,
                    max_value: 250
                }
            }
        },
        isRequiredPaciente() {
            const tiposAtividade = [
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
            ]

            return tiposAtividade.includes(this.data.model.atividade.atividadeTipoId)
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                        { key: "cidadao.cns", searchable: true },
                    ],
                },
            }
        },
        maskPeso() {

            const value = this.data.model.participantes.peso ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 1) {
                        return '#.###';
                    } else if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
        maskAltura() {

            const value = this.data.model.participantes.altura ?? null;

            if (value) {
                const decimalSeparatorIndex = value.indexOf('.') !== -1 ? value.indexOf('.') : value.indexOf(',');

                if (decimalSeparatorIndex !== -1) {

                    const valueLength = value.indexOf('.') !== -1
                        ? value.split(".")[0].length
                        : value.split(",")[0].length

                    if (valueLength === 2) {
                        return '##.###';
                    }
                    else {
                        return '###.###';
                    }
                } else {
                    return '###';
                }
            }

            return '###';
        },
    },
    created() {
        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {

            if(this.data.model.participante.cidadao) {
                const participante = this.data.model.participantes.find(participante => participante.id == this.data.model.participante.cidadao.id)

                if (participante) {

                    this.showAlert('O participante já foi cadastrado anteriormente na ficha.', "Atenção")
                    return false
                }

                const param = {
                    id: this.data.model.participante.cidadao.id,
                    nome: this.data.model.participante.cidadao.cidadao.nome,
                    nomeSocial: this.data.model.participante.cidadao.cidadao.nomeSocial,
                    cns: this.data.model.participante.cidadao.cidadao.cns,
                    avaliacaoAlterada: this.data.model.participante.avaliacaoAlterada ? 'Sim' : '-',
                    peso: this.data.model.participante.peso ?? null,
                    altura: this.data.model.participante.altura ?? null,
                    parouFumar: this.data.model.participante.parouFumar ? 'Sim' : '-',
                    abandonouGrupo: this.data.model.participante.abandonouGrupo ? 'Sim' : '-'
                }

                if (this.index !== null) {

                    this.$set(this.data.model.participantes, this.index, this.clone(param))
                } else {

                    this.data.model.participantes.push(this.clone(param))
                }

                this.data.model.atividade.avaliacoesAlteradas = this.data.model.participantes.filter(participante => participante.avaliacaoAlterada == 'Sim').length

                this.resetForm()
            }
        },
        resetForm() {

            this.data.model.participante = []
        },
    },
    mixins: [repository, error, object, formats, data, stringCase],
    props: {
        data: { type: Object, required: false },
        id: { type: Number },
        index: { type: Number, default: null },
    },
    watch: {
        "data.model.atividade.totalParticipantes": function () {

            if(this.data.model.atividade.totalParticipantes != '' && this.data.model.atividade.totalParticipantes < this.data.model.participantes.length) {

                this.showAlert('A quantidade de participantes não pode ser menor do que os participantes cadastrados.', "Atenção")

                this.data.model.atividade.totalParticipantes = this.data.model.participantes.length

            }
        },
        "data.model.saudePratica": function (pratica) {

            const tiposPratica = [
                this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_1,
                this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_2,
                this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_3,
                this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_4
            ]

            if (tiposPratica.some(r => pratica.indexOf(r) >= 0)) {
                return this.isPnctDisabled = false
            } else {
                return this.isPnctDisabled = true
            }
        },
        "data.model.participante.cidadao.id": function () {

            const participante = this.data.model.participante.cidadao

            if(participante) {

                this.setLoading()

                this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: participante.id}))
                    .then(response => {

                        if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                            this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                            this.data.model.participante.cidadao = null
                            return false
                        }

                        if (participante.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                            && response.data.additionals.avisaCnsTemporarioInvalido) {

                                const confirm = async () => {

                                    return false
                                }

                                const cancelar = async () => {

                                    this.data.model.participante.cidadao = null
                                    return false
                                }

                                const msg = `Paciente com cadastro temporário. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancelar)

                                return false
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        }
    },
}
</script>